import { render, staticRenderFns } from "./askQuestion.vue?vue&type=template&id=3582f99f"
import script from "./askQuestion.vue?vue&type=script&lang=js"
export * from "./askQuestion.vue?vue&type=script&lang=js"
import style0 from "./askQuestion.vue?vue&type=style&index=0&id=3582f99f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports